export const setTheme = (color: string, variable: string) => {
  const root = document.documentElement;
  root?.style.setProperty(variable, color);
};

export const getTheme = (variable: string) => {
  const root = document.documentElement;
  return root.style.getPropertyValue(variable);
};
